import { Client } from './Client';
export function buildClient(config) {
    return new Client(config);
}
//# sourceMappingURL=buildClient.js.map